import axios from 'axios';

// ---------------------------------------------------------
// Environment Detection
// ---------------------------------------------------------

const origin = window.location.origin;
const hostname = window.location.hostname;

// Local
const isLocal =
  hostname === 'localhost' ||
  hostname === '127.0.0.1';

// UAT
const isUAT =
  hostname === 'uat-eshp.diveinprojects.com';

// Production / Live
const isProduction =
  hostname === 'quonnect.diveinprojects.com';

// ---------------------------------------------------------
// API URL
// ---------------------------------------------------------

export const API_URL = isLocal
  ? 'http://localhost:5000/api'
  : isUAT
    ? 'https://uat-eshp-node.diveinprojects.com/api'
    : isProduction
      ? 'https://eshp-node.diveinprojects.com/api'
      : 'http://localhost:5000/api';

// ---------------------------------------------------------
// Microsoft Azure AD Configuration
// ---------------------------------------------------------

export const CLIENT_ID =
  '4052a213-d406-4764-97ce-6b3a03709ae5';

export const AUTHORITY =
  'https://login.microsoftonline.com/c3c3e928-85e8-43af-80c2-e705fe9b0cb0';

// ---------------------------------------------------------
// Redirect URI
// ---------------------------------------------------------

export const REDIRECT_URI = isLocal
  ? 'http://localhost:3000'
  : isUAT
    ? 'https://uat-eshp.diveinprojects.com'
    : 'https://quonnect.diveinprojects.com';

// ---------------------------------------------------------
// Microsoft Graph API
// ---------------------------------------------------------

export const GRAPH_API_ENDPOINT =
  'https://graph.microsoft.com/v1.0';

export const GRAPH_SCOPES = [
  'openid',
  'profile',
  'email',
  'User.Read'
];

// ---------------------------------------------------------
// Axios Instance
// ---------------------------------------------------------

export const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});